export const DefaultNullStringValue = '--';

export const ShipmentDetailsModalStatus = {
    details: 1,
    updateDetails: 2,
    createHistory: 3,
    updateHistory: 4
};

export const ShipmentStatuses = {
    booked: 100
};